import React, { FC, memo, useCallback, useMemo } from 'react';
import useLocalStorage from 'react-localstorage-hook';

import Typography from '@mui/material/Typography';

import { authorizationActions } from '@contexts/common/AuthorizationContext';
import { modalActions } from '@contexts/common/ModalContext';

import { useSwitchChain } from '@hooks/common/useSwitchChain';

import { ConfigChainIds } from '@tools/wagmi';

import Button from '@components/common/Button';
import ModalWrapper from '@components/common/Modal/ModalWrapper';

import {
  AVAILABLE_CHAINS_LIST,
  CHAINS_NAME,
  DEFAULT_CHAIN_ID,
} from '@constants/common/chain.constants';
import { CURRENT_CHAIN_ID } from '@constants/common/localStorage.constants';
import { Variant } from '@constants/common/ui.constants';

import useStyles from './styles.module';

const WrongNetworkModal: FC = () => {
  const { classes } = useStyles();

  const [chainInStorage] = useLocalStorage(CURRENT_CHAIN_ID);
  const { switchChain } = useSwitchChain();

  const availableChains = useMemo(
    () => AVAILABLE_CHAINS_LIST.map((chainId) => CHAINS_NAME[chainId]),
    [],
  );

  const handleChange = useCallback(async () => {
    await switchChain((chainInStorage as ConfigChainIds) || DEFAULT_CHAIN_ID);
  }, [chainInStorage, switchChain]);

  const handleDisconnect = useCallback(() => {
    authorizationActions.handleDisconnect();
    modalActions.hide();
  }, []);

  return (
    <ModalWrapper
      isHideCloseBtn
      disableBackdropClick
      title="Check your network"
    >
      <div className={classes.content}>
        <div className={classes.contentBox}>
          <Typography
            variant="body2"
            color={(theme) => theme.palette.custom.text.dark}
          >
            Currently this page only supported in {availableChains.join(', ')}
          </Typography>
        </div>
        <div className={classes.btns}>
          <Button
            fullWidth
            onClick={handleDisconnect}
            variant={Variant.Secondary}
          >
            Disconnect Wallet
          </Button>
          <Button fullWidth onClick={handleChange} variant={Variant.Contained}>
            Switch network
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default memo(WrongNetworkModal);
